"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.glitchTwoConfig = exports.glitchOneConfig = exports.glitchImgTwoConfig = exports.glitchImgOneConfig = exports.glitchImage = exports.getKeyFrames = void 0;
/**********************
 * ANIMATION 1 CONFIG *
 **********************/
var glitchOneConfig = exports.glitchOneConfig = function glitchOneConfig() {
  var mobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var width = mobile ? 90 : 160;
  var height = mobile ? 27 : 50;
  var config = {
    name: 'glitch-1',
    intensity: 40,
    width,
    height
  };
  return config;
};
var glitchImgOneConfig = exports.glitchImgOneConfig = {
  name: 'glitch-1',
  seconds: 2,
  secondsAlt: 3,
  leftOffset: 0
};

/**********************
 * ANIMATION 2 CONFIG *
 **********************/
var glitchTwoConfig = exports.glitchTwoConfig = function glitchTwoConfig() {
  var mobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var width = mobile ? 90 : 160;
  var height = mobile ? 27 : 50;
  var config = {
    name: 'glitch-2',
    intensity: 20,
    width,
    height
  };
  return config;
};
var glitchImgTwoConfig = exports.glitchImgTwoConfig = {
  name: 'glitch-2',
  seconds: 1,
  secondsAlt: 2,
  leftOffset: 0
};

/**
 * Retrieves the base image styles for the 2nd and 3rd
 * image copies such that we can clip them and animate the clipping
 */
var glitchImage = config => {
  var {
    name,
    seconds,
    secondsAlt,
    leftOffset
  } = config;
  return {
    '& > img:nth-child(1)': {
      clip: 'rect(0px, 0px, 0px, 0px)',
      left: "".concat(leftOffset + 2, "px"),
      animation: "$".concat(name, "-anim-0 ").concat(seconds, "s 1 linear alternate-reverse")
    },
    '& > img:nth-child(2)': {
      clip: 'rect(0px, 0px, 0px, 0px)',
      left: "".concat(leftOffset - 2, "px"),
      animation: "$".concat(name, "-anim-1 ").concat(secondsAlt, "s 1 linear alternate-reverse")
    }
  };
};

/**
 * Utility function: returns a random number between 0 and maxHieghtValue
 * rounded to the nearest integer
 */
exports.glitchImage = glitchImage;
var getRandomHeight = maxHeightValue => {
  /**
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random
   */
  return Math.floor(Math.random() * Math.floor(maxHeightValue));
};

/**
 * Generates the @keyframe pair objects based on our configuration
 *
 * Here we are iteratively building
 * @keyframe {
 *  percetnage: {clip}
 * }
 *
 * objects based on the configuration properties
 */
var getKeyFrames = config => {
  var {
    name,
    intensity,
    width,
    height
  } = config;
  var steps = intensity;
  var keyFrames = {};
  for (var index = 0; index < 2; index++) {
    var animationName = "@keyframes ".concat(name, "-anim-").concat(index);

    // fill keyframes 1 & 2 with a series of "steps"
    var stepPercentages = {};
    for (var innerIndex = 0; innerIndex < steps; innerIndex++) {
      var percentage = Math.round(innerIndex * (1 / steps) * 100);
      var stepName = "".concat(percentage, "%");
      var randomHeightOne = getRandomHeight(height);
      var randomHeightTwo = getRandomHeight(height);
      stepPercentages[stepName] = {
        clip: "rect(".concat(randomHeightOne, "px, ").concat(width, "px, ").concat(randomHeightTwo, "px, 0px)")
      };
    }
    keyFrames[animationName] = stepPercentages;
  }
  return keyFrames;
};

/*********
 * TYPES *
 *********/

// Config types required to generate keyframe classes

// Config types required to generate keyframe classes
exports.getKeyFrames = getKeyFrames;